import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsSpeckle } from "./endpointsSpeckle";
import { SpeckleModelModel } from "../../SpeckleImportWizard/types/SpeckleModelModel";

export function speckleCreateModel(
  projectId: number,
  speckleProjectId: string,
  model: Omit<SpeckleModelModel, "id">,
) {
  return authenticatedAxios
    .request<SpeckleModelModel>({
      ...endpointsSpeckle.createModel(projectId, speckleProjectId),
      data: model,
    })
    .then((resp) => resp.data);
}
